<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible" ref="modal">     
        <div class="u-window m-reward-modal">           
            <div class="u-btn close" @click="destroyElement"></div>
            <div class="dialog-wrapper">
                <div class="dialog-body">
                    <h6 class="title web"></h6>
                    <div class="reward-view">
                        <div class="reward-row" v-for="(item,index) in pack_config" :key="index">
                            <div class="label" :class="'r-' + (index + 1)"></div>

                            <ul class="reward-list">
                                <li v-for="(r,k) in item" :key="k"
                                v-tips="r.id">
                                    <game-item :id="r.id" :num="r.num" :locked="true"></game-item>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <h6 class="title game"></h6>
                    <div class="reward-view">
                        <div class="reward-row game-evt" v-for="(item,index) in evt_config" :key="index">
                            <div class="label" :class="'g-' + (index + 1)"></div>

                            <ul class="reward-list">
                                <li v-for="(r,k) in item" :key="k"
                                v-tips="r.id">
                                    <game-item :id="r.id" :num="r.num" :locked="true"></game-item>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>   
            </div>         
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>      
</template>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            pack_config : [
                [{name : '',id : 'ML71',num : 35},{name : '',id : 'ML72',num : 1},{name : '',id : 'LJ30',num : 1},{name : '',id : 'E559',num : 2},{name : '',id : 'LE95',num : 9}],
                [{name : '',id : 'LY49',num : 10},{name : '',id : 'LE95',num : 10},{name : '',id : 'X472',num : 20},{name : '',id : 'LY31',num : 10},{name : '',id : 'X230',num : 100}],
                [{name : '',id : 'D355',num : 2},{name : '',id : 'KW99',num : 10},{name : '',id : 'E246',num : 1},{name : '',id : 'X567',num : 5},{name : '',id : 'X472',num : 10}]
            ],
            evt_config : [
                [{name : '',id : 'LK66',num : 1},{name : '',id : 'KR48',num : 5},{name : '',id : 'KQ66',num : 5},],
                [{name : '',id : 'X230',num : 100},{name : '',id : 'K172',num : 5},{name : '',id : 'KR48',num : 5},],
                [{name : '',id : 'MI33',num : 2},{name : '',id : 'KR48',num : 5},{name : '',id : 'LE76',num : 5},],
            ],            
        }
    }, 
    methods : {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },      
    },
}
</script>

<style scoped>
/* share */
.m-reward-modal{
    width: 734px;
    height: 852px;
    background-image: url(~@/assets/images/utils/bg-reward-show.png);
}

.dialog-wrapper{
    /* padding: 24px 0 0; */
}

h6.web{
    /* height: 14px; */
    width: 458px;
    height: 30px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-reward_web.png);
}

h6.game{
    /* height: 14px; */
    width: 458px;
    height: 30px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/utils/title-reward_game.png);
}

.reward-row{
    display: flex;
    align-items: center;
    position: relative;
    width: 683px;
    height: 104px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/utils/bg-reward-line.png);
}

.reward-row .label{
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 185px;
    height: 104px;
    background-position: center;
    background-repeat: no-repeat;
}

.label.r-1{
    background-image: url(~@/assets/images/utils/label-r-team.png);
}

.label.r-2{
    background-image: url(~@/assets/images/utils/label-r-token.png);
}

.label.r-3{
    background-image: url(~@/assets/images/utils/label-r-corp.png);
}

.label.g-1{
    background-image: url(~@/assets/images/utils/label-r-race.png);
}

.label.g-2{
    background-image: url(~@/assets/images/utils/label-r-evt.png);
}

.label.g-3{
    background-image: url(~@/assets/images/utils/label-r-online.png);
}



.reward-row ul{
    display: flex;
    justify-content: space-between;
    width: 370px;
    /* padding-top: 50px; */
    padding-left: 250px;
    padding-right: 54px;
    box-sizing: content-box;
}


.reward-row.game-evt ul{
    /* justify-content: flex-start; */
}

.reward-row.game-evt li{
    /* margin-right: 20px; */
}

.reward-row li{
    width: 46px;
    height: 46px;
}
</style>


// WEBPACK FOOTER //
// src/components/RewardModal/rewardModal.vue